<template>
	<div class="box">
		<div class="box-header with-border">
			<div class="user-block">
				<div
					class="username"
					title="Abrir informações da empresa"
					@click="openModalClient"
				>
					<a>{{ data.razao }}</a>
				</div>
				<span
					class="description"
					title="Isolar O.S. desta empresa"
					@click="IsolarCliente(data.cnpj)"
				>
					{{ data.cnpj }}
				</span>
			</div>

			<div class="box-tools">
				<template v-if="status == 1">
					<button
						@click="toogleBody($refs.boxBody)"
						type="button"
						class="btn btn-box-tool"
					>
						<i class="fa fa-minus"></i>
					</button>
				</template>
				<template v-else>
					<button
						@click="toogleBody($refs.boxBody)"
						type="button"
						class="btn btn-box-tool"
					>
						<i class="fa fa-plus"></i>
					</button>
				</template>
			</div>
		</div>

		<div ref="boxBody" class="box-body">
			<item-servico
				v-for="(servico, id) in data.servicos"
				:key="id"
				:data="servico"
				:idServico="id"
			/>
		</div>
		<md-open-client ref="mdOpenClient" disabled />
	</div>
</template>
<script>
	import ItemServico from './item-servico.vue';
	import ToogleFunction from '../js/ToogleFunction.mixin.js';
	import mdOpenClient from '../../../../cadastros/customers/modal.vue';

	export default {
		props: ['data'],
		inject: ['IsolarCliente', 'GetClientData'],
		components: {
			ItemServico,
			mdOpenClient,
		},
		mixins: [ToogleFunction],
		methods: {
			openModalClient() {
				const ClientData = this.GetClientData(this.data.cnpj);
				this.$refs.mdOpenClient.open(ClientData);
			},
		},
		mounted() {
			this.toogleBody(this.$refs.boxBody, 0);
		},
	};
</script>
<style scoped>
	.user-block {
		cursor: pointer;
	}
	.username,
	.description {
		margin: 0px;
	}
	.box-body {
		background: #f4f4f4;
		padding: 10px !important;
		width: 100% !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/ModeAgroup/components/item-empresa.vue